import React from 'react';
import { Box } from 'grommet';

export const TabContent = ({ ...rest }) => (
  <Box pad={{ vertical: 'medium' }} {...rest} />
);